import Promise from "bluebird";
import BaseView from "scripts/views/baseView";
import HybridPageableMediaCollection from "scripts/collections/hybridPageableMediaCollection";
import CategoryCollection from "scripts/collections/categoryCollection";
import { redirectToFragment } from "scripts/utils/routerHelpers";
import inject from "scripts/ioc/inject";
import template from "templates/newHomePage.hbs";
import templateCategoryTile from "templates/categoryTile.hbs";
import templateCurationTileSmall from "templates/curationTileSmall.hbs";
import "glider-js/glider.min.css";
import Glider from "glider-js";

const chan = Backbone.Radio.channel;

class CategoryTile extends BaseView {
  get className() {
    return "bb-category-tile";
  }

  render() {
    this.$el.html(
      templateCategoryTile({
        bisacCode: this.model.get("bisacCode"),
        name: this.model.get("name"),
        // iconUrl: this.model.get("iconUrl"),
      }),
    );

    this.$el.find(".bb-category-tile-thumbnail").css({
      "background-image": `url('${this.model.get("iconUrl")}')`,
    });

    return this;
  }
}

class CurationTileSmall extends BaseView {
  get events() {
    return {
      click: "onClick",
    };
  }

  render() {
    this.$el.html(
      templateCurationTileSmall({
        id: this.model.get("id"),
        title: this.model.get("title"),
        subtitle: this.model.get("subtitle"),
        thumbnailUrl: this.model.get("thumbnailUrl"),
      }),
    );

    return this;
  }
}

class NewHomePageView extends BaseView {
  constructor(options, securityService = inject("securityService")) {
    super(options);
    this.showMenu = options.showMenu;

    this.hideCurations =
      securityService
        .getUser()
        .getActiveOrganizationDynamicProperty("hideNewHomepageCurations") ===
      "1";

    if (!this.hideCurations) {
      this.curationCollection = new HybridPageableMediaCollection([], {
        path: "/curations",
        state: {
          currentPage: 0,
          pageSize: 10,
        },
      });
    }

    this.categoryCollection = new CategoryCollection();
  }

  get className() {
    return "bb-new-home-page";
  }

  get events() {
    return {
      "submit #target-new-home-search-form": "onSubmit",
    };
  }

  onSubmit() {
    const $input = $("#target-new-home-search-form").find("input");
    const query = $input.val();

    if (query) {
      $input.blur();

      const urlFragment = `search-results/${encodeURIComponent(
        "g=" + encodeURIComponent(query),
      )}`;

      redirectToFragment(urlFragment);
    }

    return false;
  }

  render() {
    this.$el.html(template());

    if (!this.hideCurations && this.curationCollection.length) {
      this.$el.find(".bb-new-home-curations-section").removeClass("hide");

      const curationTileContainer = this.$el.find(".bb-curations-slider");

      this.curationCollection.forEach(model => {
        this.addSubView(new CurationTileSmall({ model }))
          .appendTo(curationTileContainer)
          .render();
      });

      this.curationsGlider = new Glider(
        document.querySelector(".bb-curations-slider"),
        {
          slidesToScroll: "auto",
          // slidesToScroll: 1,
          slidesToShow: "auto",
          itemWidth: 325,
          draggable: true,
          dragVelocity: 1,
          // dots: ".bb-curations-slider-dots",
          arrows: {
            prev: ".bb-curations-slider-left-button",
            next: ".bb-curations-slider-right-button",
          },
        },
      );
    }

    if (this.categoryCollection.length) {
      this.$el.find(".bb-new-home-categories-section").removeClass("hide");

      const categoryTilesContainer = this.$el.find(
        ".bb-category-tiles-container",
      );

      this.categoryCollection.forEach(model => {
        this.addSubView(new CategoryTile({ model }))
          .appendTo(categoryTilesContainer)
          .render();
      });
    }

    if (this.showMenu) {
      chan("display").trigger("openMenuOverlay", true);
    }

    return this;
  }

  sync() {
    if (!this.hideCurations) {
      return Promise.all([
        this.curationCollection.fetch(),
        this.categoryCollection.fetch(),
      ]);
    } else {
      return this.categoryCollection.fetch();
    }
  }

  close() {
    if (this.curationsGlider) {
      this.curationsGlider.destroy();
    }

    super.close();
  }
}

export default NewHomePageView;
